import React from 'react';

export const ImageIcon = ({ width = 16, height = 17, color = "black", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className={className}
                d="M3.33333 14.5C2.96667 14.5 2.65289 14.3696 2.392 14.1087C2.13111 13.8478 2.00044 13.5338 2 13.1667V3.83333C2 3.46667 2.13067 3.15289 2.392 2.892C2.65333 2.63111 2.96711 2.50044 3.33333 2.5H12.6667C13.0333 2.5 13.3473 2.63067 13.6087 2.892C13.87 3.15333 14.0004 3.46711 14 3.83333V13.1667C14 13.5333 13.8696 13.8473 13.6087 14.1087C13.3478 14.37 13.0338 14.5004 12.6667 14.5H3.33333ZM4.66667 11.8333H11.3333C11.4667 11.8333 11.5667 11.7722 11.6333 11.65C11.7 11.5278 11.6889 11.4111 11.6 11.3L9.76667 8.85C9.7 8.76111 9.61111 8.71667 9.5 8.71667C9.38889 8.71667 9.3 8.76111 9.23333 8.85L7.5 11.1667L6.26667 9.51667C6.2 9.42778 6.11111 9.38333 6 9.38333C5.88889 9.38333 5.8 9.42778 5.73333 9.51667L4.4 11.3C4.31111 11.4111 4.3 11.5278 4.36667 11.65C4.43333 11.7722 4.53333 11.8333 4.66667 11.8333Z"
                fill={color}
            />
        </svg>
    );
};